import * as ngCore from '@angular/core'

import { Store } from '../store'

import * as menu from './menu'

@ngCore.Component({
  imports: [menu.Component],
  selector: 'atn-navbar-logo',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /**
   * Determines whether to show the menu icon in this {@link Component}.
   * - Always shows if the user can access admin pages or GraphQL sandbox.
   * - Otherwise, shows only if there are multiple tenants or any tenant has multiple zones.
   */
  public shouldShowMenuIconSg = ngCore.computed(
    (
      tenants = this.store.availableTenantsSg(),
      canAccessAdminPages = this.store.canAccessAdminPagesSg(),
      canAccessGraphqlSandbox = this.store.canAccessGraphqlSandboxSg(),
    ) =>
      canAccessAdminPages ||
      canAccessGraphqlSandbox ||
      tenants.length > 1 ||
      tenants.some(t => t.zones.length > 1),
  )
}
